$(document).on('turbo:load', function() {
    if(!$("body").tooltip) return;
    $("body").tooltip({ selector: '[data-bs-toggle=tooltip]' });
});
